import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** The card ticks round a couple of degrees with a short mechanical overshoot. */
export const clockworkCardMotion = (): FlowThemeCardMotion => ({
  variants: {
    enter: (direction: CardDirection) => ({ opacity: 0, rotate: direction > 0 ? -3 : 3, scale: 0.98 }),
    center: { opacity: 1, rotate: 0, scale: 1 },
    exit: (direction: CardDirection) => ({ opacity: 0, rotate: direction > 0 ? 3 : -3, scale: 0.98 }),
  },
  transition: { type: 'spring', stiffness: 260, damping: 18, opacity: { duration: 0.35 } },
});
